/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Thirdsubjectgraduation2Inputs */

const de__field_thirdsubjectgraduation2 = /** @type {(inputs: _Field_Thirdsubjectgraduation2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abschluss Drittfach`)
};

/**

* @param {_Field_Thirdsubjectgraduation2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_thirdsubjectgraduation2 = /** @type {((inputs?: _Field_Thirdsubjectgraduation2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Thirdsubjectgraduation2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_thirdsubjectgraduation2(inputs)
});
export { _field_thirdsubjectgraduation2 as "_field_thirdSubjectGraduation" }